// Dependencies
import React, { useState, useEffect, useCallback } from "react";
import { Spin, Icon } from "antd";
import { css } from "emotion";
import styled from "@emotion/styled";
import { useDispatch } from "react-redux";

const actions = [
  require("../app/others/articulos/redux/actions")["getArticulos"],
  require("../app/others/proveedores/redux/actions")["getProveedores"],
  require("../app/others/tiposActCoste/redux/actions")["getTiposActCoste"],
  require("../app/others/tiposUnidad/redux/actions")["getTiposUnidad"],
  require("../app/others/tiposMargen/redux/actions")["getTiposMargen"],
  require("../app/others/tarifasVenta/redux/actions")["getTarifasVenta"],
  require("../app/configuracion/repartidores/redux/actions")["getRepartidores"],
  require("../app/configuracion/usuarios/redux/actions")["getUsuarios"],
];

const Title = styled.h2`
  margin-top: 20px;
`;

const LoadingContainer = styled.div`
  min-height: 100vh;
  padding-top: 6em;
  text-align: center;
  background-color: rgb(240, 242, 245);
`;

const withInitialData = (WrappedComponent) => (props) => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchData = useCallback(async () => {
    try {
      setLoading(true);
      await Promise.all(actions.map((action) => dispatch(action())));
      setLoading(false);
      setError(null);
    } catch (err) {
      setLoading(false);
      setError(err);
    }
  }, [dispatch]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return !loading && !error ? (
    <WrappedComponent {...props} />
  ) : loading ? (
    <LoadingContainer>
      <Spin
        indicator={
          <Icon
            type="loading"
            className={css`
              font-size: 48px;
            `}
            spin
          />
        }
      />
      <Title>Comprobando la conexión con el servidor</Title>
    </LoadingContainer>
  ) : (
    <LoadingContainer>
      <Icon
        type="warning"
        className={css`
          font-size: 60px;
        `}
      />
      <Title>Se produjo un error al comunicar con el servidor </Title>
      <div>
        <b>Actualice la página</b>
      </div>
    </LoadingContainer>
  );
};

export default withInitialData;
